import LegalPage from "@/components/LegalPage";
import { PRIVACY_MARKDOWN } from "@/legal/privacy";

export default function Privacy() {
  return <LegalPage content={PRIVACY_MARKDOWN} testId="page-privacy" />;
}
